<template>
    <slide-x-left-transition :duration="index < 5 ? 400+(index*100) : 400" :delay="index < 5 ? 200+(index*100) : 200">
        <ion-card v-if="show" mode="ios" style="margin: 0 0 20px 0px">
            <ion-item>
                <ion-label mode="md" class="ion-text-wrap">
                    <ion-badge v-if="badge" style="margin-bottom: 5px">{{ badge }}</ion-badge>
                    <h2>{{ first_name }} {{ last_name }}</h2>
                    <div v-for="(item,index) in roles" :key="index">
                        <p>
                            <svg v-if="item.verified" class="icon icon-checkmark-black" style="width:15px"><use xlink:href="#icon-checkmark-black"></use></svg>
                            <span>{{ item.role_name }} {{ item.place_name }}</span>
                        </p>
                    </div>
                </ion-label>
            </ion-item>
            <ion-card-content>
                <ion-button mode="ios" fill="outline" size="small" @click="goTo('UserEmployeesDetail', employee_id)">Zobacz szczegóły</ion-button>
            </ion-card-content>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    import goTo from '@/mixins/goto';

    export default {
        name: 'ItemUserEmployee',
        props: ['index', 'employee_id', 'first_name', 'last_name', 'roles', 'badge'],
        mixins: [goTo],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
        methods: {

        }
    }
</script>


<style lang="scss" scoped>
    ion-card-content{
        padding: 6px 15px;
    }
    .badge-gray{
        background: #d2d2d2;
    }
</style>